import { ReducerState } from '../../store.types';

export const monitoringSelector = ({ monitoring }: ReducerState) => monitoring;
